module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('data-table', {
    attrs: {
      "table-ref": "requests-table",
      "title": "Requests",
      "icon": "fa fa-share-alt",
      "hide-org-badge": "",
      "show-search": false,
      "url": '/actions/site/' + _vm.rowData.id + '/null/rt',
      "fields": _vm.fields,
      "detail-component": "requests-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2e93652"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/SiteRequests.vue
// module id = 1682
// module chunks = 0